import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Effect$dUncurried from "../Effect.Uncurried/index.js";
import * as Foreign from "../Foreign/index.js";
import {parseJSONImpl} from "./foreign.js";
const parseJSON = /* #__PURE__ */ (() => {
  const $0 = Data$dBifunctor.bifunctorEither.bimap(x => Data$dNonEmpty.$NonEmpty(Foreign.$ForeignError("ForeignError", Effect$dException.message(x)), Data$dList$dTypes.Nil))(x => x);
  const $1 = Effect$dUncurried.runEffectFn1(parseJSONImpl);
  return x => $0((() => {
    const $2 = $1(x);
    return Effect$dException.catchException(x$1 => () => Data$dEither.$Either("Left", x$1))(() => {
      const a$p = $2();
      return Data$dEither.$Either("Right", a$p);
    });
  })()());
})();
const decodeJSONWith = f => {
  const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity);
  return a => $0.bind(parseJSON(a))(f);
};
export {decodeJSONWith, parseJSON};
export * from "./foreign.js";
